import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Chart,
  Interval,
  Coordinate,
  Legend,
  View,
  Annotation,
  Tooltip,
} from 'bizcharts';
import { translateNumbersToPersian } from 'utils';

const RingChart = ({
  data = [],
  content = {},
  intervalConfig = {},
  annotationConfig = {},
}) => {
  return (
    <Chart
      renderer='svg'
      className='ring-chart'
      placeholder={false}
      height={120}
      width={120}
      padding='auto'
      autoFit
    >
      <Legend visible={false} />
      <Tooltip visible={false} />
      <View
        data={data}
        scale={{
          percent: {
            formatter: (val) => {
              return translateNumbersToPersian(`${val}%`);
            },
          },
        }}
      >
        <Coordinate type='theta' innerRadius={0.75} />

        <Interval
          position='percent'
          adjust='stack'
          // color={["type", ["rgba(100, 100, 255, 0.6)", "#eee"]]}
          //  color={['type', [brandFill, '#AADBDD']]}
          size={16}
          // style={{ fillOpacity: 0.6 }}
          // label={['type', {offset: 40}]}
          {...intervalConfig}
        />
        <Annotation.Text
          position={['50%', '50%']}
          content={translateNumbersToPersian(content.percent)}
          style={{
            fontSize: '24',
            textAlign: 'center',
            ...annotationConfig,
          }}
        />

        <Tooltip
          crosshairs={{
            type: 'y',
          }}
        >
          {(_title, items) => {
            return (
              <div className='flex tooltip'>
                <div className='tooltip-title'>{items[0].name}</div>
                <div className='tooltip-value'>{items[0]?.value || 0}</div>
              </div>
            );
          }}
        </Tooltip>
      </View>
    </Chart>
  );
};

RingChart.propTypes = {
  data: PropTypes.array,
  content: PropTypes.object,
  intervalConfig: PropTypes.object,
  annotationConfig: PropTypes.object,
};

export default memo(RingChart);
